import React, {Component} from 'react';


class BusinessInsights extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  async componentDidMount() {
  
  }


  render() {
    return (
        <div >            
            <p>Body Text</p>
        </div>
    )
  }
}

export default BusinessInsights;